import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'ramda';

import { setClubsData } from '@interlayer/js/app/store/reducers/clubsService/actions';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

import { useDynamicTags } from 'js/app/hooks/useDynamicTags';
import { useClubsSelector } from 'js/app/store/hooks/useClubsSelector';
import { fromArrayToObject } from 'js/app/utils/common.util';
import { useDataFetch } from 'js/hooks/useDataFetch';
import { postFormData } from 'js/utils/fetch.util';

const shouldFetch = (params) => !params?.clubs?.length;

// eslint-disable-next-line camelcase
const filterClub = ({ hall_code, address }) => Boolean(hall_code && address);

const fetch = (url) => {
    const requestBody = new FormData();
    requestBody.append('apiKey', window.Playtech.Variables['club-api-apiKey'] || '5418a40c-d74c-4d58-a258-a086d4a952b9');

    return postFormData({ requestBody, url });
};

export const useClubData = () => {
    const dispatch = useDispatch();
    const { clubsData } = useClubsSelector();
    const [dTagClubAPIUrl = 'https://www.galabingoclubs.co.uk/api/get_clubs/'] = useDynamicTags([DYNAMIC_TAG_NAMES.clubAPIUrl]);

    const onResponseClubData = useCallback((response) => {
        const clubs = response.filter(filterClub);
        const clubsObj = fromArrayToObject({
            data: response,
            key: 'hall_code',
            filter: filterClub
        });

        const data = { clubs, clubsObj };

        dispatch(setClubsData(data));

        return data;
    }, [dispatch]);

    const fetchWrap = useCallback(() => fetch(dTagClubAPIUrl), [dTagClubAPIUrl]);

    return useDataFetch({
        fetch: fetchWrap,
        params: clubsData,
        onResponse: onResponseClubData,
        shouldFetch,
        initialData: clubsData,
        initialIsLoading: isEmpty(clubsData.clubs)
    });
};
